const API_VERSIONS = {
    V1: 'v1',
    V2: 'v2',
    V3: 'v3'
};

export default API_VERSIONS;